import { inject } from "@angular/core";
import { Router } from "@angular/router";
import { AuthService } from "../services/auth.service";
import { RoleService } from "../services/role.service";
import { UserRole } from "../models/user-role.model";
import { environment } from "../../environments/environment";
import { map, switchMap, take } from "rxjs/operators";
import { of } from "rxjs";

export const authGuard = () => {
	const authService = inject(AuthService);
	const roleService = inject(RoleService);
	const router = inject(Router);

	return roleService.getCurrentUserWithRoles().pipe(
		take(1),
		switchMap((userWithRoles) => {
			if (!userWithRoles) {
				router.navigate(["/login"]);
				return of(false);
			}

			const roles = userWithRoles.roles;
			let onlyAssessee = false;

			if (Array.isArray(roles)) {
				onlyAssessee =
					roles.length === 1 &&
					roles.includes(UserRole.ASSESSEE as string);
			} else if (roles && typeof roles === "object") {
				const trueRoles = Object.keys(roles).filter((key) => roles[key] === true);
				onlyAssessee =
					trueRoles.length === 1 &&
					trueRoles.includes(UserRole.ASSESSEE as string);
			}

			if (onlyAssessee) {
				window.location.href = environment.MEMBERS_APP_URL;
				return of(false);
			}

			return of(true);
		}),
	);
};
